import { PORTAL_ROLES } from '@/authorization/authorization.constants';
import { xorEncryptDecrypt } from '@/common/utils/encryption.utils';
import webStorage, { LOCAL_STORAGE_KEYS } from '@/core/web-storage/webStorage';
import { ErrorType } from '@/payroll-period/utils/payrollPeriod.utils';

function getBoardId() {
  const storageBoardId = webStorage.local.getItem(LOCAL_STORAGE_KEYS.BOARD_ID);
  return storageBoardId as string;
}

function getUserId() {
  const storageUserId = webStorage.local.getItem(LOCAL_STORAGE_KEYS.USER_ID);
  return storageUserId as string;
}

function getUserPortalRole() {
  const storageUserPortalRole = webStorage.local.getItem(LOCAL_STORAGE_KEYS.PORTAL_ROLE);
  const decryptedUserPortalRole = xorEncryptDecrypt(storageUserPortalRole as string);
  return decryptedUserPortalRole as PORTAL_ROLES;
}

function getUserAgreementState() {
  const storageUserAgreementState = webStorage.local.getItem(
    LOCAL_STORAGE_KEYS.USER_AGREEMENT_STATE,
  );
  return storageUserAgreementState === null ? null : storageUserAgreementState === 'true';
}

function getUserName() {
  const storageUserName = webStorage.local.getItem(LOCAL_STORAGE_KEYS.USER_NAME);
  return storageUserName as string;
}

function getIsUserBoardSelected() {
  const storageBoardSelectedState = webStorage.local.getItem(
    LOCAL_STORAGE_KEYS.IS_USER_BOARD_SELECTED,
  );
  return storageBoardSelectedState == 'true';
}

function getEncryptionNonce() {
  const storageEncryptionNonce = webStorage.local.getItem(LOCAL_STORAGE_KEYS.ENCRYPTION_NONCE);
  return storageEncryptionNonce as string;
}

function getIsUserLoginSet() {
  const storageUserLoginState = webStorage.local.getItem(LOCAL_STORAGE_KEYS.IS_USER_LOGIN_SET);
  return storageUserLoginState == 'true';
}

function getSessionActivityTimestamp() {
  const storageSessionActivityTimestamp = webStorage.local.getItem(
    LOCAL_STORAGE_KEYS.SESSION_ACTIVITY_TIMESTAMP,
  ) as string;
  return new Date(storageSessionActivityTimestamp);
}

function getErrorType() {
  const storageErrorType = webStorage.local.getItem(LOCAL_STORAGE_KEYS.ERROR_TYPE);
  return (storageErrorType ?? '-1') as ErrorType;
}

export {
  getBoardId,
  getUserId,
  getUserPortalRole,
  getUserAgreementState,
  getUserName,
  getIsUserBoardSelected,
  getEncryptionNonce,
  getIsUserLoginSet,
  getSessionActivityTimestamp,
  getErrorType,
};
